module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAABjBAMAAAB9FaOmAAAAMFBMVEX80RYAnmAAcsZ+om68xCkipVabvjL30BcxqFGlwC87qk+wwiwqp1M+q049qk750BdNjqb0AAABK0lEQVR4Xu3WzU0DMRQE4PckCESAeCNF/IQbFVDCtpAOSAdpISWkBDpICymFDlICiqydIzuzB7jYV88na/2e7Y13jo/4ZYCj/op00kknnXTSyQ3BtUq+SFIlINmWRhJFvFbJEzE0AoAEg0p2jWyAUkgCKOKVRxYAoJBvBlMhnPxkrKZJtiDJSiXPlwZrkSnCOWIMKtlFbMbIBHkAgxBJklyNmVmr+N/i75hcl0fWRa5+svpyjx3YY3Ino9qC+nlJvMbCJeCpFM/+CTjz7CskYlxqkO+x5UhCJNwsrPU7+dDItvSbny0gvy/3jejvC5s4Qicnn3BWJkuf3Pok5pNj+JtskzeZMFEW2bOSMkmLsDLlkZhHjiZJIGzy4pJA2WQfNkmf3P3bf3InnfwAGX0Hc3dEkFcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/uis/assets/images/flags/vc.png
// module id = 651
// module chunks = 0